import { DirectUpload } from '@rails/activestorage'

class DirectUploader {
  constructor(file, url) {
    this.filename = file.name
    this.upload = new DirectUpload(file, url, this)
  }

  start(input) {
    this.createFileHiddenField(input)

    this.upload.create((_error, _blob) => {})
  }

  directUploadWillStoreFileWithXHR(request) {
    const hiddenField = document.querySelector(`input[filename="${this.filename}"]`)

    request.upload.addEventListener('progress', event => this.storeProgressOnHiddenField(event, hiddenField))
  }

  storeProgressOnHiddenField(event, hiddenField) {
    let progress = ((event.loaded / event.total) * 100).toFixed(1)
    hiddenField.setAttribute('progress', progress)
  }

  createFileHiddenField(input) {
    const hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('filename', this.filename)
    hiddenField.name = input.name

    input.appendChild(hiddenField)
  }
}

export { DirectUploader }
